import { render, staticRenderFns } from "./SavvyPage.vue?vue&type=template&id=179d4c86&scoped=true&"
import script from "./SavvyPage.vue?vue&type=script&lang=ts&"
export * from "./SavvyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d4c86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('179d4c86', component.options)
    } else {
      api.reload('179d4c86', component.options)
    }
    module.hot.accept("./SavvyPage.vue?vue&type=template&id=179d4c86&scoped=true&", function () {
      api.rerender('179d4c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/savvy/SavvyPage.vue"
export default component.exports